(function ($) {
	const model = document.getElementById('projects-map-section__modal');

	if (!model) return;

	const mapModel = new bootstrap.Modal(model);
	const modelBody = model.querySelector('.modal-body');

	const pins = document.querySelectorAll('.projects-map-section__pin');

	pins.forEach(function (pin) {
		pin.addEventListener('click', (event) => {
			pinClick(event);
		});
		pin.addEventListener('touchstart', (event) => {
			pinClick(event);
		});
	});

	function pinClick(event) {
		event.preventDefault();

		const pin = event.target;
		const id = pin.dataset.postId;
		const title = pin.getAttribute('aria-label');

		openProjectModal(id, title);
	}

	function openProjectModal(id, title) {
		modelBody.innerHTML = '<section class="project-hero">' +
			'<div class="container-xxl">' +
				'<h1 class="heading">' + title + '</h1>' +
				'<div class="project-info-wrap" aria-hidden="true"></div>' +
			'</div>' +
			'<div class="status-bar" aria-hidden="true"></div>' +
		'</section>' +
		'<div class="p-5 text-center">' +
			'<div class="spinner-border text-primary" role="status">' +
				'<span class="visually-hidden">Loading project information...</span>' +
			'</div>' +
		'</div>';

		mapModel.show();

		$.ajax({
			url: projectMapAJAX.ajaxurl,
			type: 'post',
			data: {
				action: 'kwb_ajax_project_model',
				nonce: projectMapAJAX.nonce,
				post_id: id,
			},
			success: function (result) {
				modelBody.innerHTML = result;

				SwipersInit();

				window.filterButtons(model);
				window.initResources();
			},
		});
	}
})(jQuery);
